angular.module('gym.contacts').factory('ContactGoCardlessService', ["$http", function($http) {
  return {
    setDefault: function(paymentMethod) {
      var paymentMethodUrl, url;
      paymentMethodUrl = paymentMethod.getRestangularUrl();
      url = `${paymentMethodUrl.replace('gocardless', 'mandates')}/set_default`;
      return $http.put(url);
    }
  };
}]);
